import React, { useState, useRef, useEffect } from 'react';
import axios from "axios";

export default function OrgDetails({ isExistingCustomer, setBillingAddress, billingAddress, setIsExistingCustomer, customer, onOrgSelect, gstin, setgstin, onCopyToShipping, onTransformedAddress, isChecked, SetisChecked, setCustomerIds, setContactInformation, contactInformation, handleBlurget, handleCustomerIdGeneration, setBrandName, brandName, setIsSameBilling, isSameAsBilling, searchOrg, setSearchOrg, setShippingAddresses, seteditmode, editmode, setbygstcustomer, accountantInformation, setAccountantInformation, showRadioButton }) {
    const [shippingAddress, setShippingAddress] = useState({
        line1: '',
        line2: '',
        pincode: '',
        city: '',
        state: '',
    });
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [filteredOrgs, setFilteredOrgs] = useState([]);
    const [showOrgDropdown, setShowOrgDropdown] = useState(false);
    const [showGstinDropdown, setShowGstinDropdown] = useState(false);
    const inputRef = useRef(null);
    const [isSameAsLocation, setIsSameAsLocation] = useState(false);
    const [isSameAsAccountant, setIsSameAsAccountant] = useState(false);



    useEffect(() => {
        if (isExistingCustomer && searchOrg) {
            console.log("checkedit")
            const filtered = customer.filter(org =>
                org.name.toLowerCase().includes(searchOrg.toLowerCase())
            );

            if (searchOrg === filtered) {
                setShowOrgDropdown(false)
            } else {
                console.log("checkedit12")
                if (editmode) {
                    console.log("checkedit13")
                    setFilteredOrgs([]);
                    setShowOrgDropdown(false);
                } else if (editmode === false) {
                    console.log("checkedit14")
                    setFilteredOrgs(filtered);
                    setShowOrgDropdown(true);
                }

            }

        } else {
            // clearAllFields();
        }
    }, [searchOrg, customer, isExistingCustomer]);

    useEffect(() => {
        if (selectedOrg) {
            setgstin(prevGstin => ({
                ...prevGstin,
                email: selectedOrg.email || prevGstin.email,
                name: selectedOrg.name || prevGstin.name
            }));
            const location = selectedOrg.gstin?.[0]?.address?.location || "";
            const { line1, line2 } = splitAddress(location);
            setBillingAddress({
                line1,
                line2,
                pincode: selectedOrg.gstin?.[0]?.address?.pin || '',
                city: selectedOrg.gstin?.[0]?.address?.city || '',
                state: selectedOrg.gstin?.[0]?.address?.state || ''
            });
            console.log(selectedOrg, "checkselectedordg")
            onOrgSelect(selectedOrg.customer_id, {
                name: selectedOrg.name
            });
            setShowOrgDropdown(false);
        }
    }, [selectedOrg]);

    function splitAddress(address) {
        if (!address || typeof address !== "string") {
            return { line1: "", line2: "" }; // Handle undefined/null/invalid input
        }

        const splitKeywords = [" SHOPPING CENTRE", " ROAD", " STREET", " AVENUE", " SECTOR", " BLOCK", " PHASE", " COLONY", " APARTMENT"];

        for (let keyword of splitKeywords) {
            let index = address.indexOf(keyword);
            if (index !== -1) {
                return {
                    line1: address.substring(0, index + keyword.length).trim(),
                    line2: address.substring(index + keyword.length).trim()
                };
            }
        }

        // Fallback: Split at the closest comma if no keyword is found
        const words = address.split(",");
        const mid = Math.floor(words.length / 2);

        return {
            line1: words.slice(0, mid).join(", ").trim() || address,
            line2: words.slice(mid).join(", ").trim() || ""
        };
    }



    const clearAllFields = () => {
        setSelectedOrg(null);
        setgstin({
            number: '',
            billingName: '',
            billingAddress: '',
            name: '',
            email: ''
        })
        setBillingAddress({
            line1: '',
            line2: '',
            pincode: '',
            city: '',
            state: '',
        })
        setShippingAddresses([])
        setFilteredOrgs([]);
        setShowOrgDropdown(false);
        setShowGstinDropdown(false);
    };

    const handleCustomerTypeChange = (isExisting) => {
        setIsExistingCustomer(isExisting);
        if (!isExisting) {
            clearAllFields();
            setSearchOrg('');
        }
    };


    const handleSearchOrgChange = (e) => {
        setSearchOrg(e.target.value);
        if (isExistingCustomer) {
            if (e.target.value === searchOrg) {
                setShowOrgDropdown(false);
            } else {
                setShowOrgDropdown(true);
            }
        }
        if (!e.target.value) {
            clearAllFields();
        }
    };

    const handleOrgSelect = (org) => {
        setSearchOrg(org.name);
        setSelectedOrg(org);
        setCustomerIds(org.customer_id);
        const gstinData = org.gstin && org.gstin.length > 0
            ? org.gstin[0]
            : '';

        setgstin({
            number: gstinData.number,
            billingName: '',
            billingAddress: '',
            name: org.name,
            phoneNumber: "",
        });
    };




    const handleGstinSelect = (selectedGstin) => {
        if (selectedGstin && selectedGstin.address) {
            const { location, city, state, pin } = selectedGstin.address;
            const formattedBillingAddress = `${location}, ${city}, ${state}, ${pin}`;
            setgstin((prevGstin) => ({
                ...prevGstin,
                number: selectedGstin.number,
                name: selectedGstin.billingname,
                // gstin: formattedBillingAddress, // Use the formatted address
            }));
            const { line1, line2 } = splitAddress(location);

            // Split the address into parts for setBillingAddress
            setBillingAddress({
                line1: line1,
                line2: line2,
                city: city || '',
                state: state || '',
                pincode: pin || '',
            });

            // Hide the dropdown after selecting the GSTIN
            setShowGstinDropdown(false);
        } else {
            console.warn("Address is undefined for the selected GSTIN.");
            // Optional: Set default values or handle this case as needed
        }
    };


    const handleSearchOrgFocus = () => {
        if (isExistingCustomer && searchOrg) {
            // console.log("handleserch")
            setShowOrgDropdown(true);
        }
    };

    const handleSearchOrgBlur = () => {
        setTimeout(() => {
            setShowOrgDropdown(false);
        }, 200);
    };

    const handleGstinNumberClick = () => {
        if (selectedOrg) {
            setShowGstinDropdown(!showGstinDropdown);
        }
    };

    const handleGstinBlur = () => {
        setTimeout(() => {
            setShowGstinDropdown(false);
        }, 200);
    };


    const handleCheckboxChange = (e) => {
        SetisChecked(e.target.checked);
        if (e.target.checked) {
            setShippingAddress({
                line1: '',
                line2: '',
                pincode: '',
                city: '',
                state: '',
            });
            setgstin({
                name: '',
                number: '',
                billingName: '',
                billingAddress: '',
                phoneNumber: ''
            });
            setBillingAddress({
                line1: '',
                line2: '',
                pincode: '',
                city: '',
                state: '',
            });
        } else {
            console.error("Checkbox unselected");
        }
    };


    const checkGstNumber = async (gstNumber) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_MYBACKEND_PI}/api/customer/gstcheck/${gstNumber}`);
            const data = response.data;

            if (data.exists) {
                setIsExistingCustomer(true);

                // Set GST and address details if customer exists
                const customerData = data.customer;
                if (customerData) {
                    const gstin = customerData.gstin.find(gst => gst.number === gstNumber);
                    const billingAddress = gstin?.address || {};

                    const shippingAddress = customerData.shipping_address?.[0] || {};
                    // console.log(shippingAddress, "check")
                    const transformedBillingAddress = {
                        line1: billingAddress.location?.split(",")[0] || "", // Extract line1 from location
                        line2: billingAddress.location?.split(",").slice(1).join(", ").trim() || "", // Extract line2 from location
                        city: billingAddress.city || "",
                        state: billingAddress.state || "",
                        pincode: billingAddress.pin.trim() || "",
                    };
                    // console.log(gstin.billingName, "existingcustomer")
                    setSearchOrg(customerData.name)
                    setgstin((prevGstin) => ({
                        ...prevGstin,
                        name: gstin.billingName,
                        address: transformedBillingAddress,
                        email: customerData.email
                    }));
                    setShippingAddresses(customerData.shipping_address ?? []);
                    setBillingAddress(transformedBillingAddress);
                    onTransformedAddress(transformedBillingAddress)
                    setCustomerIds(customerData.customer_id)
                }
                return true; // Customer exists
            } else {
                // console.log('Not an old customer');
                return false; // Customer does not exist
            }
        } catch (error) {
            console.error("Error checking GST number:", error);
            return false; // Return false on error as a fallback
        }
    };

    const handleFetchGST = async () => {
        if (!gstin.number) {
            alert("Please enter a GSTIN number.");
            return;
        }

        // Check if GST number exists
        const isExisting = await checkGstNumber(gstin.number);
        if (isExisting) {
            // console.log("Existing customer detected. Halting execution.");
            return; // Stop further execution if the customer is existing
        }

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SWIPE_BASE_URL}/api/user/fetch_gst_details`,
                { gstin: gstin.number },
                {
                    headers: {
                        'Authorization': `${process.env.REACT_APP_SWIPE_TOKEN}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            const responseData = response.data.response;
            // console.log(responseData.company_name, "check company name");
            if (gstin.name === '' || responseData.company_name !== gstin.name) {
                setSearchOrg(responseData.company_name);
            }
            // console.log(responseData.billing, "billing");

            const billingData = responseData.billing;
            const transformedAddress = {
                line1: billingData.address_1,
                line2: billingData.address_2,
                city: billingData.city,
                pincode: billingData.pincode,
                state: billingData.state.slice(3).toUpperCase(),
            };
            setShippingAddress(transformedAddress);
            setBillingAddress(transformedAddress);
            onTransformedAddress(transformedAddress);

            if (response.data && response.data.response && response.data.response.billing) {
                let companyName = responseData.company_name;
                setgstin((prevGstin) => ({
                    ...prevGstin,
                    name: companyName,
                    address: transformedAddress,
                }));

                // Trigger handleCustomerIdGeneration if companyName meets the condition
                if (companyName && companyName.length >= 3) {
                    setbygstcustomer(true)
                    handleCustomerIdGeneration();
                    // console.log("Customer ID generation triggered after fetching GST data");
                }
            } else {
                alert("Failed to fetch billing details. Please check the GSTIN number.");
            }
        } catch (error) {
            console.error("Error fetching GST:", error);
            alert("Failed to fetch GST details. Please try again.");
        }
    };




    const handleCopyToShipping = () => {
        if (!billingAddress.line1) {
            alert("Please enter the billing address.");
            return;
        }
        const billingData = {
            line1: billingAddress.line1,
            line2: billingAddress.line2,
            city: billingAddress.city,
            pincode: billingAddress.pincode,
            state: billingAddress.state,

        };
        if (onCopyToShipping) {
            onCopyToShipping(billingData);
        }
    };
    const handlegstinSelect = (selectedgstin) => {
        const formattedBillingAddress = `${selectedgstin.address.location}, ${selectedgstin.address.city}, ${selectedgstin.address.state}, ${selectedgstin.address.pin}`;
        setgstin({
            number: selectedgstin.number,
            billingName: selectedgstin.billingname,
            billingAddress: `${selectedgstin.address.location}, ${selectedgstin.address.city}, ${selectedgstin.address.state}, ${selectedgstin.address.pin}`
        });
        setBillingAddress(formattedBillingAddress)
        setShowGstinDropdown(false);
    };

    const handleCheckboxChange1 = () => {
        if (gstin.billingName === "" || gstin.phoneNumber === "") {
            alert("Please provide a valid contact person and contact number.");
            return;
        }

        setIsSameAsLocation(!isSameAsLocation);

        if (!isSameAsLocation) {
            setContactInformation((prev) => ({
                ...prev,
                contactPerson: gstin.billingName,
                contactNumber: gstin.phoneNumber,
            }));
        } else {
            setContactInformation((prev) => ({
                ...prev,
                contactPerson: '',
                contactNumber: '',
            }));
        }
    };

    const handleCheckboxChange2 = () => {
        if (gstin.billingName === "" || gstin.phoneNumber === "") {
            alert("Please provide a valid contact person and contact number.");
            return;
        }

        setIsSameAsAccountant(!isSameAsAccountant);

        if (!isSameAsAccountant) {
            setAccountantInformation((prev) => ({
                ...prev,
                accountantPerson: gstin.billingName,
                accountantNumber: gstin.phoneNumber,
                accountantEmail: gstin.email
            }));

        } else {
            setAccountantInformation((prev) => ({
                ...prev,
                accountantPerson: '',
                accountantNumber: '',
                accountantEmail: ''
            }));
        }
    };

    const handleBrandName = (e) => {
        setBrandName(e.target.value)
    }

    const handleCheckboxChangesame = () => {
        if (!gstin.name || gstin.name.trim() === '') { // Check if gstin.name is empty or whitespace
            alert("Please fill in the billing name first!");
        } else {
            const newIsSameAsBilling = !isSameAsBilling; // Toggle the checkbox state
            setIsSameBilling(newIsSameAsBilling);

            if (newIsSameAsBilling) {
                setBrandName(gstin.name); // Set the brand name to the billing name
            } else {
                setBrandName(''); // Clear the brand name
            }
        }
    };



    const fetchLocationData = async (pincode) => {
        if (pincode.length === 6) { // Assuming Indian pincode length
            try {
                const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
                const data = await response.json();

                if (data && data[0].Status === "Success") {
                    const postOfficeData = data[0].PostOffice[0];

                    setBillingAddress((prev) => ({
                        ...prev,
                        city: postOfficeData.District.replace(/\s*\(.*?\)/g, ""),
                        state: postOfficeData.State,
                    }));

                    // console.log('billing address', billingAddress);
                } else {
                    console.error("Invalid Pincode");
                }
            } catch (error) {
                console.error("Failed to fetch location data:", error);
            }
        }
    };
    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };
    const [emailError, setEmailError] = useState("");
    const handleEmailChange = (e) => {
        const email = e.target.value;
        setgstin((prevGstin) => ({ ...prevGstin, email }));

        if (!validateEmail(email)) {
            setEmailError("Invalid email address");
        } else {
            setEmailError("");
        }
    };

    return (
        <div className="bg-white shadow-md rounded-xl border-2 p-6">
            <div className='flex flex-col justify-between items-start mb-4'>
                <h1 className="font-medium text-lg mb-2">Billing Details</h1>
                {!showRadioButton && (<div className="flex  items-start">
                    <div className="flex items-center mb-2">
                        <input
                            type="radio"
                            id="existingCustomer"
                            name="customerType"
                            className="mr-2"
                            checked={isExistingCustomer}
                            onChange={() => handleCustomerTypeChange(true)}
                        />
                        <label htmlFor="existingCustomer" className="font-semibold">Existing Customer</label>
                    </div> &nbsp;
                    <div className="flex items-center">
                        <input
                            type="radio"
                            id="newCustomer"
                            name="customerType"
                            className="mr-2"
                            checked={!isExistingCustomer}
                            onChange={() => handleCustomerTypeChange(false)}
                        />
                        <label htmlFor="newCustomer" className="font-semibold">New Customer</label>
                    </div>
                </div>)}
            </div>
            <div className="flex flex-col gap-4">
                <div className="flex flex-col sm:flex-row gap-4">
                    <div className="flex flex-col w-full sm:w-[45%] relative">
                        <label htmlFor="customerName" className="mb-2 font-medium">Billing Name:<span style={{ color: "red" }}>*</span></label>
                        <div className="relative">
                            {isExistingCustomer ? (
                                <input
                                    ref={inputRef}
                                    id="searchOrg"
                                    className="border-2 border-gray-400 p-2 rounded w-full"
                                    placeholder="Search Existing Customer"
                                    value={searchOrg}
                                    onChange={handleSearchOrgChange}
                                    onFocus={handleSearchOrgFocus}
                                    onBlur={handleSearchOrgBlur}
                                />
                            ) : (
                                <input
                                    id="billingName"
                                    className="border-2 border-gray-400 p-2 rounded w-full"
                                    placeholder="Enter Billing Name"
                                    value={gstin.name}
                                    onBlur={handleBlurget}
                                    onChange={(e) =>
                                        setgstin((prevGstin) => ({
                                            ...prevGstin,
                                            name: e.target.value
                                        }))
                                    }
                                />
                            )}
                            {showOrgDropdown === true ? (
                                <ul className="absolute z-10 w-full bg-white border border-gray-300 mt-1 max-h-60 overflow-auto rounded shadow-md">
                                    {filteredOrgs.map((org) => (
                                        <li
                                            key={org.customer_id}
                                            className="p-2 hover:bg-gray-100 cursor-pointer"
                                            onMouseDown={() => handleOrgSelect(org)}  // <-- change here
                                        >
                                            {org.name}
                                        </li>
                                    ))}
                                </ul>
                            ) : ''}
                        </div>
                    </div>
                    <div className="flex flex-col w-full sm:w-[45%] ml-auto">
                        <label htmlFor="email" className="mb-2 font-medium">Email:<span style={{ color: "red" }}>*</span></label>
                        <input
                            id="email"
                            type="email"
                            className="border-2 border-gray-300 p-2 rounded"
                            placeholder="Email Address"
                            value={gstin.email}
                            required
                            onChange={handleEmailChange}
                        />
                        {emailError && <p className="text-red-500">{emailError}</p>}
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-4">
                    <div className="flex flex-col w-full sm:w-[45%] relative">
                        <label htmlFor="gstinNumber" className="mb-2 font-medium">GSTIN:</label>
                        <div className="flex relative">
                            <input
                                type="text"
                                value={gstin.number}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    const formattedInput = input.toUpperCase().replace(/\s+/g, "");
                                    if (formattedInput.length <= 15) {
                                        setgstin((prevGstin) => ({
                                            ...prevGstin,
                                            number: formattedInput
                                        }));
                                    }
                                }}
                                className="flex-grow p-2 border rounded-l w-28"
                                placeholder="Enter the GSTIN number"
                                onClick={handleGstinNumberClick}
                            />
                            <button
                                className="bg-primary text-white px-4 rounded-r"
                                onClick={handleFetchGST}
                            >
                                Fetch Details
                            </button>
                            {showGstinDropdown && selectedOrg && selectedOrg.gstin && (
                                <ul className="absolute z-50 w-full bg-white border border-gray-300 mt-1 max-h-40 overflow-y-auto top-full left-0 shadow-md">
                                    {selectedOrg.gstin.map((gstinItem) => (
                                        <li
                                            key={gstinItem.number}
                                            className="p-2 hover:bg-gray-100 cursor-pointer"
                                            onMouseDown={() => handleGstinSelect(gstinItem)}>
                                            {gstinItem.number}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="flex flex-col w-full sm:w-[45%] relative">
                            <label htmlFor="billingAddress" className="mb-2 font-medium">Brand Name:</label>
                            <input
                                type="text"
                                id="brand_name"
                                className="border-2 border-gray-300 p-2 rounded mb-2"
                                placeholder="Brand_Name"
                                value={brandName}
                                onChange={handleBrandName}
                                required
                            />
                        </div>

                        <div className="flex items-center mt-2">
                            <input
                                type="checkbox"
                                id="sameAsBilling"
                                className="mr-2"
                                checked={isSameAsBilling}
                                onChange={handleCheckboxChangesame}
                            />
                            <label htmlFor="sameAsBilling" className="font-medium">Same as Billing Name</label>
                        </div>
                    </div>
                    <div className="flex flex-col w-full sm:w-[45%] ml-auto">
                        <label htmlFor="billingAddress" className="mb-2 font-medium">Billing Address: <span style={{ color: "red" }}>*</span></label>
                        <input
                            type="text"
                            id="line1"
                            className="border-2 border-gray-300 p-2 rounded mb-2"
                            placeholder="Line 1"
                            value={billingAddress.line1}
                            onChange={(e) => setBillingAddress({ ...billingAddress, line1: e.target.value })}
                            required
                        />

                        <input
                            type="text"
                            id="line2"
                            className="border-2 border-gray-300 p-2 rounded mb-2"
                            placeholder="Line 2"
                            value={billingAddress.line2}
                            onChange={(e) => setBillingAddress({ ...billingAddress, line2: e.target.value })}
                            required
                        />
                        <input
                            type="text"
                            id="pincode"
                            className="border-2 border-gray-300 p-2 rounded mb-2"
                            placeholder="Pincode"
                            value={billingAddress.pincode}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                if (value.length <= 6) {
                                    setBillingAddress({ ...billingAddress, pincode: value });
                                }
                            }}
                            onBlur={(e) => {
                                const value = e.target.value;
                                if (value && value.length === 6) {
                                    fetchLocationData(value); // call only if 6 digits entered
                                } else if (value.length > 0 && value.length < 6) {
                                    alert("Please enter a valid 6-digit pincode");
                                }
                            }}
                            maxLength={6}
                            inputMode="numeric"
                            pattern="\d{6}"
                            title="Please enter a valid 6-digit pincode"
                            required
                        />

                        <div className="flex space-x-2">
                            <input
                                type="text"
                                id="city"
                                className="border-2 border-gray-300 p-2 rounded w-full"
                                placeholder="City"
                                value={billingAddress.city}
                                onChange={(e) => setBillingAddress({ ...billingAddress, city: e.target.value })}
                                required
                            />

                            <input
                                type="text"
                                id="state"
                                className="border-2 border-gray-300 p-2 rounded w-full"
                                placeholder="State"
                                value={billingAddress.state.toUpperCase()}
                                onChange={(e) => setBillingAddress({ ...billingAddress, state: e.target.value })}
                                required
                            />
                        </div>


                    </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-4">
                    <div className="flex flex-col w-full sm:w-[45%]">
                        <label htmlFor="superadminname" className="mb-2 font-medium">Owner Name: <span style={{ color: "red" }}>*</span></label>
                        <input
                            id="superadminname"
                            className="border-2 border-gray-400 p-2 rounded w-full"
                            placeholder="Enter Owner Name"
                            value={gstin.billingName}
                            required
                            onChange={(e) =>
                                setgstin((prevGstin) => ({
                                    ...prevGstin,
                                    billingName: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="flex flex-col w-full sm:w-[45%] ml-auto">
                        <label htmlFor="phoneNumber" className="mb-2 font-medium">
                            Owner Number: <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            id="phoneNumber"
                            className="border-2 border-gray-300 p-2 rounded"
                            placeholder="Phone Number"
                            value={gstin.phoneNumber}
                            required
                            onChange={(e) => {
                                const input = e.target.value;
                                if (/^\d{0,10}$/.test(input)) {
                                    setgstin((prevGstin) => ({
                                        ...prevGstin,
                                        phoneNumber: input,
                                    }));
                                }
                            }}
                            onBlur={(e) => {
                                // optional: mark as touched or validate on blur
                                const input = e.target.value;
                                if (input.length !== 10) {
                                    alert("Phone number must be exactly 10 digits");
                                    setgstin((prevGstin) => ({
                                        ...prevGstin,
                                        phoneNumber: "", // reset field
                                    }));
                                }
                            }}
                        />
                        {gstin.phoneNumber?.length > 0 && gstin.phoneNumber.length !== 10 && (
                            <p className="text-red-500 text-xs mt-1">
                                Phone number must be exactly 10 digits
                            </p>
                        )}
                        <p className="text-red-500 text-xs mt-1">
                            Payment link will be sent to this number
                        </p>
                    </div>



                </div>

                <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
                    <div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="sameAsLocation"
                                checked={isSameAsLocation}
                                onChange={handleCheckboxChange1}
                                className="mr-2"
                            />
                            <label htmlFor="sameAsLocation" className="ml-2 text-md text-gray-700">
                                Use Customer as contact person
                            </label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="sameAsAccountant"
                                checked={isSameAsAccountant}
                                onChange={handleCheckboxChange2}
                                className="mr-2"
                            />
                            <label htmlFor="sameAsAccountant" className="ml-2 text-md text-gray-700">
                                Use Customer as Acountant person
                            </label>
                        </div>
                    </div>
                    <div className="flex justify-end mt-4 sm:mt-0">
                        <button
                            className="text-primary border border-primary bg-white px-6 py-2 rounded hover:bg-primary hover:text-white transition-colors"
                            onClick={handleCopyToShipping}
                        >
                            Copy to Shipping Address
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
}